@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.favoritepoints

data class AddressDetailsDto(
    val building: String,
    val floor: String,
    val apartment: String,
)
